import { render, staticRenderFns } from "./CmgEmployeeRewardsHowItWorksModal.vue?vue&type=template&id=4764077a&scoped=true&lang=pug"
import script from "./cmg-employee-rewards-how-it-works-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-employee-rewards-how-it-works-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgEmployeeRewardsHowItWorksModal.vue?vue&type=style&index=0&id=4764077a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4764077a",
  null
  
)

export default component.exports